import HotelsList from './HotelsList'

export default HotelsList
